import React from 'react';
import Banner from '../components/Banner';
import Header from '../components/Header';
import '../components/css/Toc.css';

const Toc = () => {
    return (
        <>
            <Header />
            <Banner />
            <div className='toc'>
                <h1>Obchodné podmienky</h1>
                <p>
                    Tieto obchodné podmienky upravujú vzťah medzi prevádzkovateľom webovej stránky a používateľom. Používaním tejto stránky súhlasíte s týmito podmienkami. Ak nesúhlasíte s týmito podmienkami, prosím, nevyužívajte túto stránku.
                </p>
                <h2>1. Prístup a používanie</h2>
                <p>
                    Používatelia sú oprávnení pristupovať na webovú stránku a využívať jej obsah iba na účely, ktoré sú v súlade so zákonmi Slovenskej republiky a týmito obchodnými podmienkami. Prevádzkovateľ si vyhradzuje právo zablokovať prístup používateľovi, ktorý porušuje tieto podmienky.
                </p>
                <h2>2. Autorské práva</h2>
                <p>
                    Všetok obsah zverejnený na tejto webovej stránke je chránený autorským právom. Používatelia nesmú obsah stránky kopírovať, šíriť alebo inak využívať na komerčné účely bez predchádzajúceho písomného súhlasu prevádzkovateľa.
                </p>
                <h2>3. Zodpovednosť za obsah</h2>
                <p>
                    Prevádzkovateľ nenesie zodpovednosť za obsah, ktorý poskytujú používatelia stránky. Používatelia sú zodpovední za obsah, ktorý zverejnia, a sú povinní dodržiavať všetky platné zákony a predpisy.
                </p>
                <h2>4. Ochrana osobných údajov</h2>
                <p>
                    Prevádzkovateľ sa zaväzuje chrániť osobné údaje používateľov v súlade s platnými predpismi o ochrane osobných údajov. Používanie webovej stránky môže zahŕňať zber a spracovanie osobných údajov, pričom používatelia budú informovaní o tom, ako sa tieto údaje spracúvajú.
                </p>
                <h2>5. Zmena obchodných podmienok</h2>
                <p>
                    Prevádzkovateľ si vyhradzuje právo kedykoľvek zmeniť tieto obchodné podmienky. Akékoľvek zmeny budú zverejnené na tejto stránke a budú účinné okamžite po ich zverejnení. Používatelia sú zodpovední za pravidelné kontrolovanie týchto podmienok.
                </p>
                <h2>6. Ukončenie používania</h2>
                <p>
                    Prevádzkovateľ si vyhradzuje právo zablokovať prístup používateľovi, ktorý porušuje tieto podmienky. Používateľ môže kedykoľvek ukončiť používanie tejto webovej stránky.
                </p>
                <h2>7. Kontakty</h2>
                <p>
                    Ak máte akékoľvek otázky týkajúce sa týchto obchodných podmienok, kontaktujte nás na emailovej adrese: <a className='email' href="mailto:info@sluzbomat.sk">info@sluzbomat.sk</a>
                </p>
            </div>
        </>
    );
};

export default Toc;
